var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpenRegularWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.625 15.61h-3.797v-3.994c0-.623-.503-1.125-1.125-1.125H16.63l-4.124-3.945a.287.287 0 0 0-.193-.077H3.375c-.622 0-1.125.502-1.125 1.125v20.812c0 .623.503 1.125 1.125 1.125h24.54c.456 0 .87-.277 1.043-.703l4.711-11.672a1.124 1.124 0 0 0-1.044-1.547zm-6.328 0H8.367c-.457 0-.872.277-1.044.703l-2.542 6.3V9h6.627l4.205 4.022h10.684v2.587z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenRegularWhite);
export default __webpack_public_path__ + "static/media/folder-open-regular-white.a734a86694a6ec6dec81208af5908860.svg";
export { ForwardRef as ReactComponent };